module.exports = {"360826100":"澄江镇","360826102":"桥头镇","360826103":"禾市镇","360826104":"螺溪镇","360826105":"苏溪镇","360826106":"马市镇","360826107":"塘洲镇","360826108":"冠朝镇","360826109":"沙村镇","360826110":"老营盘镇","360826111":"小龙镇","360826112":"灌溪镇","360826113":"苑前镇","360826114":"万合镇","360826115":"沿溪镇","360826200":"石山乡","360826201":"南溪乡","360826202":"上模乡","360826203":"水槎乡","360826204":"上圯乡","360826205":"中龙乡","360826402":"小龙矿区管委会","360826404":"井冈山机场","360826405":"泰和县高新产业园区","360826501":"武山垦殖场","360826502":"综合垦殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360826.json
// module id = 1425
// module chunks = 0